// extracted by css-extract-rspack-plugin
export default {"stageListWrapper":"stage-list-wrapper--vQj9YRFTn6YU2Yg8"};